import './styles/Experiences.scss';
import barclays from '../svg/barclays.png'
import merrill from '../svg/merrill-lynch.png'
import reuters from '../svg/reuters.png'
import unilever from '../svg/unilever.svg'
import orion from '../svg/orion-protocol.png'
import blocksquare from '../svg/blocksquare.svg'

function Experiences() {


    return (
    <section className='experiences'>
        <p className='desc1'>
        Our team members have experience working with some of the leading
        brands...</p>
        <div className='brands'>
            <img src={barclays} />
            <img src={merrill} />
            <img src={reuters} />
            <img src={unilever} />
            <img src={orion} />
            <img className='blocksquare' src={blocksquare} />
        </div>
    </section>
     
    )
}

export default Experiences;